export enum PageNotFoundReasonCode {
  FLOW_CODE = 'FLOW_CODE', // El flujo no es reconocible
  REQUEST_ID = 'REQUEST_ID', // La solicitud no es reconocible
  PATH = 'PATH', // El path no es reconocible
  CATEGORY_CODE = 'CATEGORY_CODE', // La categoría no es reconocible
  CATEGORY_OR_FLOW_CODE = 'CATEGORY_OR_FLOW_CODE' // La categoría o flujo no es reconocible
}

export const PageNotFoundReasons: Record<PageNotFoundReasonCode, string> = {
  [PageNotFoundReasonCode.FLOW_CODE]: 'El flujo no es reconocible.',
  [PageNotFoundReasonCode.REQUEST_ID]: 'La solicitud no es reconocible.',
  [PageNotFoundReasonCode.PATH]: 'El path no es reconocible.',
  [PageNotFoundReasonCode.CATEGORY_CODE]: 'La categoria no es reconocible.',
  [PageNotFoundReasonCode.CATEGORY_OR_FLOW_CODE]: 'La categoria o flujo no es reconocible.',
};